import { render, staticRenderFns } from "./IntlTelInput.vue?vue&type=template&id=30634469&"
import script from "./IntlTelInput.vue?vue&type=script&lang=js&"
export * from "./IntlTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports